import { useAppSelector } from "@/store"
import { selectConnStats } from "@/stores/conn_stats_slice"
import { useEffect, useRef, useState } from "react"

export function useAutoLogoutAudio(timeGapNum: number) {
  const { isPlayingAudio } = useAppSelector(selectConnStats)
  const timeoutIdRef = useRef<number | null>(null)
  const [idle, setIdle] = useState<boolean>(false)

  useEffect(() => {
    if (!isPlayingAudio) {
      timeoutIdRef.current = setTimeout(() => {
        // 规定时间内用户无任何操作（视频/开会 静音状态），则自动登出
        setIdle(true)
      }, timeGapNum) as unknown as number
    } else {
      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current)
        timeoutIdRef.current = null
        setIdle(false)
      }
    }

    return () => {
      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current)
      }
    }
  }, [isPlayingAudio, timeGapNum])

  return idle
}
